<template>
	<vxe-modal v-model="modalShow" :width="width" :height="height" show-footer destroy-on-close @show="show"
		@hide="hide" transfer :lock-scroll="false">
		<template #title>
			<div>{{extra.title?extra.title:'授权'}}</div>
		</template>
		<template #default>
			<el-tabs v-model="activeName" @tab-click="handleClick" type="card">
				<el-tab-pane label="部门" name="department" v-if="authtab.includes('department')">
					<span slot="label">部门<span class="point" v-if="num.department!=0">{{num.department}}</span> </span>
					<department ref="authdepartment" @datachange="datachange" />
				</el-tab-pane>
				<el-tab-pane label="人员" name="staff" v-if="authtab.includes('staff')">
					<span slot="label">人员<span class="point" v-if="num.staff!=0">{{num.staff}}</span> </span>
					<staff ref="authstaff" @datachange="datachange" />
				</el-tab-pane>
				<el-tab-pane label="岗位" name="postjob" v-if="authtab.includes('postjob')">
					<span slot="label">岗位<span class="point" v-if="num.postjob!=0">{{num.postjob}}</span> </span>
					<postjob ref="authpostjob" @datachange="datachange" />
				</el-tab-pane>
				<el-tab-pane label="职务级别" name="joblevel" v-if="authtab.includes('joblevel')">
					<span slot="label">职务级别<span class="point" v-if="num.joblevel!=0">{{num.joblevel}}</span> </span>
					<joblevel ref="authjoblevel" @datachange="datachange" />
				</el-tab-pane>
				<el-tab-pane label="分组" name="group" v-if="authtab.includes('group')">
					<span slot="label">分组<span class="point" v-if="num.group!=0">{{num.group}}</span> </span>
					<group ref="authgroup" @datachange="datachange" />
				</el-tab-pane>
				<el-tab-pane label="相对位置(人员)" name="relation" v-if="authtab.includes('relation')">
					<span slot="label">相对位置(人员)<span class="point" v-if="num.relation!=0">{{num.relation}}</span> </span>
					<relation ref="authrelation" @datachange="datachange" />
				</el-tab-pane>
				<el-tab-pane label="相对位置(部门)" name="relationdepartment'" v-if="authtab.includes('relationdepartment')">
					<span slot="label">相对位置(部门)<span class="point" v-if="num.relationdepartment!=0">{{num.relationdepartment}}</span> </span>
					<relationdepartment ref="authrelationdepartment" @datachange="datachange" />
				</el-tab-pane>
				<el-tab-pane label="表单字段" name="formitem" v-if="authtab.includes('formitem')">
					<span slot="label">表单字段<span class="point" v-if="num.formitem!=0">{{num.formitem}}</span> </span>
					<formitem :formid="extra.formid" :type="extra.formitemtype" ref="authformitem" @datachange="datachange" />
				</el-tab-pane>
			</el-tabs>
			<transition name="el-fade-in-linear">
				<div class="full flex form_loading" v-if="loading"
					style="background-color: rgba(255, 255, 255, .5);z-index: 999;color: #409EFF;">
					<i class="vxe-icon-refresh roll"></i>
					<span>正在加载</span>
				</div>
			</transition>
		</template>
		<template #footer>
			<vxe-button status="" content="取消" @click="modalShow=false"></vxe-button>
			<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
		</template>

	</vxe-modal>

</template>
<style>
	.el-form-item {
		margin-bottom: 0px;
	}

	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}
</style>
<style scoped>
	.point {
		margin-left: 4px;
		font-size: 12px;
		color: white;
		background-color: red;
		box-sizing: border-box;
		padding: 0 6px;
		border-radius: 1000px;

	}
</style>
<script>
	import department from '@_system/components/auth/department.vue'
	import staff from '@_system/components/auth/staff.vue'
	import postjob from '@_system/components/auth/postjob.vue'
	import joblevel from '@_system/components/auth/joblevel.vue'
	import group from '@_system/components/auth/group.vue'
	import relation from '@_system/components/auth/relation.vue'
	import relationdepartment from '@_system/components/auth/relationdepartment.vue'
	import formitem from '@_system/components/auth/formitem.vue'
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			},
			title: {
				type: String,
				default: () => {
					return '授权'
				}
			},
			authtab: {
				type: Array,
				default: () => {
					return ['department','staff','postjob','joblevel','group']
				}
			},
			isauth: {
				type: Boolean,
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				name: 'auth',
				activeName: '',
				store: {},
				fApi: {},
				modalShow: false,
				loading: true,
				width: '0',
				height: '0',
				num: {
					department: 0,
					staff: 0,
					postjob: 0,
					joblevel: 0,
					group: 0,
					relation: 0,
					relationdepartment:0,
					formitem: 0
				},
				sourcedata:[],

			}

		},

		watch: {

		},
		computed: {

		},
		created() {
			//console.log(this.id, this.extra.type)
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				this.width = 800
				this.height = 800
				this.activeName = this.authtab[0]
				this.modalShow = true
				
			},
			show() {
				this.sourcedata = this.extra.value
				//console.log(this.sourcedata,11)
				if(this.sourcedata){
					this.initdata()
				}
				this.loading = false
			},
			initdata(){
				if(this.sourcedata.auth){
					this.$nextTick(()=>{
						this.authtab.forEach((item)=>{
							this.$refs['auth' + item].setData(this.sourcedata.auth[item])
							this.num[item] = this.$refs['auth' + item].data.length
						})																		
					})
				}
			},
			hide() {
				this.loading = false
				this.back('cancle')
			},

			handleClick() {

			},
			save(formData) {
				if(this.name){
					this.$api[this.name].save(formData).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.back('cancle')
					})
				}
			},
			initsubmitdata(){
				let auth = {}
				this.authtab.forEach((item)=>{
					//console.log('auth'+item,111)
					auth[item] = this.$refs['auth'+item].submitData()
				})
				return auth
			},
			submit() {
				let formData = {
					auth: this.initsubmitdata()
				}
				this.$emit('submit', {
					data: formData.auth
				})
				this.back()
			},
			datachange(e) {
				this.num[e.type] = e.data.length
			},
			back(type) {
				this.loading = false
				this.$emit('back', {
					type: type
				})
			},

		},
		components: {
			department,
			staff,
			postjob,
			joblevel,
			group,
			relation,
			relationdepartment,
			formitem,
		}
	}
</script>
